import { actions } from './actions'

const initialState = {
  data: [],
}

export default function lessonsProgressReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_LESSONS_PROGRESS_RESULT:
      return { ...state, data: action.payload }
    default:
      return state
  }
}
